import { QuestionBlock } from "./Sections/QuestionBlock/QuestionBlock";
import { OptionsGrid } from "./Sections/OptionsGrid/OptionsGrid";
// import { Credentials } from "./Sections/Credentials/Credentials";
// import { EmotionBlock } from "./Sections/EmotionBlock/EmotionBlock";
// import { HeroSection } from "./Sections/HeroSection/HeroSection";
// import { IntroPsychologists } from "./Sections/IntroPsychologists/IntroPsychologists";
// import { UserStats } from "./Sections/UserStats/UserStats";
// import { UserHappiness } from "./Sections/UserHappiness/UserHappiness";
// import { Transformation } from "./Sections/Transformation/Transformation";
// import { EmotionalStateIntro } from "./Sections/EmotionalStateIntro/EmotionalStateIntro";
// import { CustomPlan } from "./Sections/CustomPlan/CustomPlan";
// import { DailyBenefits } from "./Sections/DailyBenefits/DailyBenefits";
// import { NeuroScience } from "./Sections/NeuroScience/NeuroScience";
// import { Overview } from "./Sections/Overview/Overview";
import { FactBlock } from "./Sections/FactBlock/FactBlock";
import { PhilosophySection } from "./Sections/PhilosophySection/PhilosophySection";
import { EffectSection } from "./Sections/EffectSection/EffectSection";
import { CalculatingSection } from "./Sections/CalculatingSection/CalculatingSection";
import { ReviewSection } from "./Sections/ReviewSection/ReviewSection";

const componentMap = {
  // HeroSection,
  QuestionBlock,
  OptionsGrid,
  // Credentials,
  // EmotionBlock,
  // IntroPsychologists,
  // UserStats,
  // UserHappiness,
  // Transformation,
  // EmotionalStateIntro,
  // CustomPlan,
  // DailyBenefits,
  // NeuroScience,
  // Overview,
  FactBlock,
  PhilosophySection,
  EffectSection,
  CalculatingSection,
  ReviewSection
};

export const renderComponent = ({ quizItem, nextSlug }) => {
  const Component = componentMap[quizItem.type];

  if (!Component) {
    console.warn(`Component not found for type: ${quizItem.type}`);
    return null;
  }

  return <Component content={quizItem} nextSlug={`/quiz/${nextSlug}/`} />;
};
